import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  data () {
    return {
      filter: this.getFilterFromRoute(),
      serverPagination: {
        descending: this.getSortingParamsFromRoute().descending,
        page: this.getPageFromRoute(),
        rowsNumber: 0, // specifying this determines pagination is server-side
        rowsPerPage: this.getRowsPerPage() || 10,
        sortBy: this.getSortingParamsFromRoute().sortBy
      },
      selectedRows: [],
      loading: false,
      data: [],
      perPageOptions: [10, 20, 40, 60]
    };
  },
  beforeMount () {
    this.restoreFiltersData();
    this.setFilterMutation();
  },
  computed: {
    ...mapGetters({
      routeQuery: 'routeQuery/full'
    })
  },
  watch: {
    visibleColumns (visibleColumns) {
      let columnsStorageData = this.getStorageData('visibleColumns');

      columnsStorageData[this.$options.name] = visibleColumns;
      localStorage.setItem('visibleColumns', JSON.stringify(columnsStorageData));
    },
    'serverPagination.rowsPerPage' (rowsPerPage) {
      let perPageStorageData = this.getStorageData('rowsPerPage');

      perPageStorageData[this.$options.name] = rowsPerPage;
      localStorage.setItem('rowsPerPage', JSON.stringify(perPageStorageData));
    },
    'serverPagination.descending' (descending) {
      this.$store.commit('routeQuery/setSorting', this.serverPagination.sortBy ? {
        [`orderBy[${this.serverPagination.sortBy}]`]: descending ? 'DESC' : 'ASC'
      } : null);
      this.changeRouteQuery();
    },
    'serverPagination.sortBy' (sortBy) {
      this.$store.commit('routeQuery/setSorting', sortBy ? {
        [`orderBy[${sortBy}]`]: this.serverPagination.descending ? 'DESC' : 'ASC'
      } : null);
      this.changeRouteQuery();
    },
    'serverPagination.page' (page) {
      this.$store.commit('routeQuery/setPage', page > 1 ? {
        page: page
      } : null);
      this.changeRouteQuery();
    },
    filter () {
      this.changeRouteQuery();
    }
  },
  methods: {
    getStorageData (name) {
      return JSON.parse(localStorage.getItem(name) || '{}');
    },
    getRowsPerPage () {
      let storage = this.getStorageData('rowsPerPage');

      if (this.$options.name in storage) {
        return storage[this.$options.name];
      }

      return null;
    },
    getVisibleColumns () {
      let storage = this.getStorageData('visibleColumns');

      if (this.$options.name in storage) {
        return storage[this.$options.name];
      }

      return null;
    },
    getQuery (pagination, filter) {
      let query = `?`;

      if (pagination.page) {
        query += `page=${pagination.page}`;
      }

      if (pagination.sortBy) {
        query += `&orderBy[${pagination.sortBy}]=${pagination.descending ? 'DESC' : 'ASC'}`;
      }
      if (pagination.rowsPerPage) {
        query += `&perPage=${pagination.rowsPerPage}`;
      }
      if (filter) {
        query += `&${filter}`;
      }

      return query;
    },
    changeRouteQuery () {
      let query = {};

      _.forOwn(this.routeQuery, val => {
        if (val) {
          query = {...query, ...val};
        }
      });

      window.history.pushState({}, '', this.$router.resolve({
        query: query
      }).href);
    },
    getRef (key) {
      return this.$refs[key];
    },
    getRefEl (key) {
      return this.$refs[key].$el;
    },
    getStyle (el) {
      return window.getComputedStyle(el);
    },
    setTableTopPadding () {
      this.getRefEl('table').style.paddingTop = this.getStyle(this.getRefEl('thead').parentNode).height;
    },
    setHeaderCellWidth () {
      let tableRow = this.getRefEl('table').querySelector('tbody tr');

      if (tableRow) {
        this.getRefEl('thead').querySelectorAll('th').forEach((item, i, arr) => {
          let col = tableRow.querySelectorAll('td')[i];

          item.style.width = '';
          item.style.minWidth = '';
          col.style.width = '';
          col.style.minWidth = '';
        });

        this.getRefEl('thead').querySelectorAll('th').forEach((item, i, arr) => {
          let col = tableRow.querySelectorAll('td')[i];
          let realWidth;

          let colWidth = this.getStyle(col).width;
          let itemWidth = this.getStyle(item).width;

          if (parseFloat(itemWidth) < parseFloat(colWidth)) {
            realWidth = colWidth;
          } else {
            realWidth = itemWidth;
          }
          item.style.width = realWidth;
          item.style.minWidth = realWidth;
          col.style.width = realWidth;
          col.style.minWidth = realWidth;
        });
      }
    },
    setHeaderScrollPosition () {
      let tableLeftPos = this.$refs.table.$el.querySelector('.q-table').getBoundingClientRect().left;
      let parentLeftPos = this.$refs.table.$el.getBoundingClientRect().left;

      this.$refs.table.$el.querySelector('.q-table-middle').addEventListener('scroll', (e) => {
        let currentTableLeftPos = this.$refs.table.$el.querySelector('.q-table').getBoundingClientRect().left;

        if (tableLeftPos !== currentTableLeftPos) {
          this.$refs.table.$el.querySelector('thead').style.left = currentTableLeftPos - parentLeftPos + 'px';
          tableLeftPos = currentTableLeftPos;
        }
      });
    },
    restorePagination () {
      let page = sessionStorage.getItem(`page`),
        rowsPerPage = sessionStorage.getItem(`rowsPerPage`);

      if (page) {
        this.serverPagination.page = JSON.parse(page);
      }

      if (rowsPerPage) {
        this.serverPagination.rowsPerPage = JSON.parse(rowsPerPage);
      }
    },

    restoreFiltersData () {
      let query = this.$route.query,
        filterRegExp = {
          'value': /^filter\[(\w*)\]\[\]$/,
          'text': /^filter\[(\w*)\]$/,
          'object': /^filter\[(\w*)\]\[(\w*)\]$/
        };

      if (query) {
        _.forOwn(query, (value, key) => {
          if ((filterRegExp.value).test(key)) {
            let name = key.match(filterRegExp.object)[1];

            this.columns.find(row => row.name === name).filter = [].concat(value);
            //this.filterCols[name] = [value]
          } else if ((filterRegExp.text).test(key)) {
            let name = key.match(filterRegExp.text)[1];

            this.columns.find(row => row.name === name).filter = value;
            //this.filterCols[name] = value
          } else if ((filterRegExp.object).test(key)) {
            let name = key.match(filterRegExp.object)[1],
              valueKey = key.match(filterRegExp.object)[2];

            let column = this.columns.find(row => row.name === name);
            
            if (column) {
              column.filter[valueKey] = value;
            } else {
              column = this.columns.find(row => row.name === `${name}.${valueKey}`);
              column.filter.push(value);
            }
            //this.filterCols[name] = this.filterCols[name] || {}
            //Object.assign(this.filterCols[name], {[valueKey]: value})
          }
        });
      }
    },
    setFilterMutation () {
      let filterParams = this.getFilterParams(this.$route.query);

      if (Object.keys(filterParams).length) {
        this.$store.commit('routeQuery/setFilter', filterParams);
      }
    },
    getPageFromRoute () {
      let query = this.$route.query;

      if ('page' in query) {
        return parseFloat(query.page);
      }

      return 1;
    },
    getSortingParamsFromRoute () {
      let query = this.$route.query,
        sortingRegExp = /^orderBy\[(\w*)\]$/,
        sortBy = null,
        descending = false;

      if (query) {
        _.forOwn(query, (value, key) => {
          if (sortingRegExp.test(key)) {
            sortBy = key.match(sortingRegExp)[1];
            descending = value === 'DESC';
          }
        });
      }

      return {
        sortBy: sortBy,
        descending: descending
      };
    },
    getFilterFromRoute () {
      let filterQuery = '',
        filterParams = this.getFilterParams(this.$route.query);

      if (!Object.keys(filterParams).length) {
        return '';
      }

      _.forOwn(filterParams, (val, key) => {
        if (val.constructor === Array) {
          val.forEach(item => {
            filterQuery += `&${key}=${item}`;
          });
        } else {
          filterQuery += `&${key}=${val}`;
        }
      });

      return filterQuery.slice(1);
    },
    getFilterParams (query) {
      return Object.keys(query)
        .filter(val => val.indexOf('filter') !== -1)
        .reduce((obj, key) => {
          obj[key] = query[key];
          return obj;
        }, {});
    },
    resetFilter (col) {
      if (Array.isArray(col.filter)) {
        col.filter = [];
      } else {
        col.filter = '';
      }
    },
    applySearch (col, index) {
      this.search(col, index, false);

      this.filtered = false;
    },
    isEmpty (value) {
      if (!value) {
        return true;
      }

      if (value.constructor === Array && value.length) {
        return false;
      } else if (value.constructor === Object && Object.keys(value).length) {
        return false;
      } else if (value.constructor === String && value !== '') {
        return false;
      }

      return true;
    },
    formatValue (value, columnName) {
      let column, columnValues, option;

      if (!(column = this.columns.find(col => col.name === columnName))) {
        return value;
      }
      if (!(columnValues = column.values)) {
        return value;
      }
      if (!(option = columnValues.find(row => row.value === value))) {
        return value;
      }

      return option.label;
    },
    formatNumber (value, factor) {
      return value * factor;
    },
    updateData (data) {
      this.data = data;
      this.selectedRows = []; // clear rows selection
    },
    updatePagination (pagination, rowsNumber) {
      pagination.rowsNumber = rowsNumber;
      this.serverPagination = pagination;
    },
    verifyResponse (response) {
      return response.config.url.lastIndexOf(this.query) !== -1
    }
  }
};


// WEBPACK FOOTER //
// ./resources/assets/js/components/HTable/helpers.js